import { 
  Home, 
  Users, 
  ClipboardList, 
  CreditCard, 
  Paintbrush, 
  Bell, 
  LogOut,
  Moon,
  Sun,
  User,
  UserPlus,
  Calendar,
  Pencil,
  Plus,
  Search,
  SearchX,
  Check,
  Eye,
  MoreVertical,
  Trash,
  MessageCircle,
  Palette,
  Image,
  Scroll,
  MonitorSmartphone,
  Loader2,
  Waves,
  Dumbbell,
  Utensils,
  Activity,
  Footprints,
  ThumbsUp,
  Flame,
  Brain,
  Torus,
  Phone,
  Sparkles,
  Save,
  ChevronLeft,
  ChevronRight,
  AlertTriangle,
  Table,
  Grid3X3,
  Settings,
  Loader2 as Loader,
  PaperclipIcon as Paperclip,
  CheckIcon as CheckMark,
  XIcon as X
} from "lucide-react";

// Export icons that are used in the application
export const HomeIcon = Home;
export const UsersIcon = Users;
export const ClipboardIcon = ClipboardList;
export const CreditCardIcon = CreditCard;
export const PaintbrushIcon = Paintbrush;
export const BellIcon = Bell;
export const LogOutIcon = LogOut;
export const MoonIcon = Moon;
export const SunIcon = Sun;
export const UserIcon = User;
export const UserPlusIcon = UserPlus;
export const CalendarIcon = Calendar;
export const PencilIcon = Pencil;
export const PlusIcon = Plus;
export const SearchIcon = Search;
export const SearchXIcon = SearchX;
export const CheckIcon = Check;
export const EyeIcon = Eye;
export const MoreVerticalIcon = MoreVertical;
export const TrashIcon = Trash;
export const MessageCircleIcon = MessageCircle;
export const PaletteIcon = Palette;
export const ImageIcon = Image;
export const ScrollIcon = Scroll;
export const MonitorSmartphoneIcon = MonitorSmartphone;
export const Loader2Icon = Loader2;
export const WaveIcon = Waves;
export const DumbbellIcon = Dumbbell;
export const UtensilsIcon = Utensils;
export const ActivityIcon = Activity;
export const FootprintsIcon = Footprints;
export const ThumbsUpIcon = ThumbsUp;
export const FlameIcon = Flame;
export const BrainIcon = Brain;
export const ToothIcon = Torus;
export const PaperclipIcon = Paperclip;
export const XIcon = X;
export const PhoneIcon = Phone;
export const SparklesIcon = Sparkles;
export const SaveIcon = Save;
export const ChevronLeftIcon = ChevronLeft;
export const ChevronRightIcon = ChevronRight;
export const AlertTriangleIcon = AlertTriangle;
export const TableIcon = Table;
export const Grid3X3Icon = Grid3X3;
export const SettingsIcon = Settings;
export const LoaderIcon = Loader;
